import { DependencyName, DependencyDataList } from "./DependencyList.interface";
import { ComponentRef } from "@angular/core";

/**
 * Widget Categories
 */
export enum WidgetCategory { A = "A", B = "B", C = "C", D = "D" }


/**
 * Interface representing a Widget item on the dashboard
 */
export interface WidgetItem {
    /**
     * Name (is used to identify the widget internally)
     */
    name: string;

    /**
     * Widget category
     */
    category: WidgetCategory;

    /**
     * Widget component Class
     */
    component: any; // Component;

    /**
     * List of dependecies, eache item should be part
     * of the keys in the DependencyList  interface
     */
    dependencies: DependencyName[];

    /**
     * Internal property indicating if the widget
     * is visible, allways set it to false
     */
    visible?: boolean;

    /**
     * The current position of the widget in the
     * sequence of widgets on the dashboard.
     * Just initialize it with 0, the algo will
     * calculate his position down the road
     */
    position?: number;

    /**
     * Whether this widget is disabled or not
     * leave, if not specified, false is assumed
     */
    disabled?: boolean;

    /**
     * Component instance
     */
    componentInstance?: ComponentRef<any>;

    /**
     * The evaluation function that decides if the
     * widget shoud be visible or not
     */
    evaluateVisibility: (data?: DependencyDataList) => boolean;

    /**
     * Get the number of slots occupied by the widget
     */
    getSlotsCount: (data?: DependencyDataList) => number;
}
